import { mechanicalServicesFields } from 'components/CommercialERS/CommercialERSInformationFields';
import {
  commercialNetworkServicesLabels,
  commercialTireServicesLabels,
  commercialMechanicalServicesLabels,
} from 'components/CommercialServices/CommercialServicesFields';

const fields = {
  // CommercialLocation_MassST
  'commercial_information.open_for_commercial_business': 'Open for Business',
  is_mobile_only: 'Mobile Only',
  mechanical_same_hours_as_tires: 'Mechanical same as Tires',
  'commercial_information.service_radius': 'Service Radius',
  'pos_type': 'POS Integration',
  'commercial_information.site_url': 'Website Address',
  mechanical_hours_of_operation: 'Mechanical Services Hours of Operations',
  tire_services_hours_of_operation: 'Tire Services Hours of Operations',

  // CommercialProducts_MassST
  x_one_tires: 'X One Tires',
  mrt_dealer: 'MRT Dealer',
  oliver_retreads: 'Oliver Retreads',
  megamile_retreads: 'MegaMile Retreads',
  ultra_low_profile_wide_design_retreads: 'Ultra Low Profile Wide Design Retreads',

  // CommercialNetworkServices
  ...commercialNetworkServicesLabels,

  // CommercialTireServices
  ...commercialTireServicesLabels,

  // commercialMechanicalServices
  ...commercialMechanicalServicesLabels,

  // CommercialERSInformation
  ...mechanicalServicesFields,
  'rv_motor_coach.rv_dealer': 'RV Dealer',
  'rv_motor_coach.motor_coach_dealer': 'Motor Coach Dealer',
  oncall_sds_dashboard: 'Enabled for use and access of the ONCall DR Dashboard',
  is_fixpix_location: 'Enabled for use and access of the FixPix App',
  autodispatch_after_hours: 'Enable ONCall Auto Dispatch After Regular Service Hours',
  'ers_tire_services.do_you_have_trucks': 'Do you have Tire Service Trucks',
  'ers_tire_services.number_of_trucks': '# of Tire Service Trucks',
  'ers_tire_services.provides_247365_ers_service': 'Provides 24/7/365 Tire ERS Service',
  'ers_mechanical_services.number_of_trucks': '# of Mechanical Service Trucks',
  'ers_mechanical_services.do_you_have_trucks': 'Do you have Mechanical Service Trucks',
  'ers_mechanical_services.provides_247365_ers_service': 'Provides 24/7/365 Mechanical ERS Service',
  'ers_mechanical_services.mechanical_same_hours_as_tires_ers_services': 'Same as Tire ERS Services',

  // Overrides
  'overrides.mcsn_member': 'MSCN Member',
  'overrides.mechanical_care_member': 'Mechanical Care Number',
  'overrides.on_mechanical_locator': 'On Mechanical Locator',
  'overrides.on_tire_locator': 'On Tire Locator',
  'overrides.service_tier_ranking': 'Service Rank',
  'overrides.tire_care_member': 'Tire Care Number',
} as any;

// Fields with specials labels for CommercialMassSTUpdate.
fields['towing.less_than_10_lbs'] = 'Towing < 10,000 lbs';
fields['towing.between_10_and_26_lbs'] = 'Towing from 10,000 to 26,000 lbs';
fields['towing.greater_than_26_lbs'] = 'Towing > 26,000 lbs';

export function fieldLabel(field: string): string {
  return fields[field];
}
